module.exports = __webpack_public_path__ + "static/media/hexagon-hiw.52ce5de5.svg";